let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Mm3C8")).then(() => parcelRequire('fJhua'));